import type { HighchartsConfig } from 'highcharts-angular';
import Highcharts from 'highcharts/highstock';

export const HIGHCHARTS_CONFIG: HighchartsConfig = {
  instance: () => Promise.resolve(Highcharts),
  modules: () => [
    import('highcharts/modules/accessibility'),
    import('highcharts/modules/boost'),
    import('highcharts/modules/xrange')
  ],
  options: {
    palette: {
      colorScheme: 'light'
    },
    chart: {
      style: {
        fontSize: '16px'
      },
      zooming: {
        type: 'x',
        mouseWheel: false
      }
    },
    credits: {
      enabled: false
    },
    scrollbar: {
      enabled: false
    },
    rangeSelector: {
      enabled: false
    },
    legend: {
      enabled: true,
      align: 'left',
      itemHiddenStyle: {
        textDecoration: 'none'
      },
      itemHoverStyle: {
        color: 'var(--text-secondary)'
      },
      itemStyle: {
        color: 'var(--text-primary)'
      }
    },
    yAxis: {
      showFirstLabel: true,
      showLastLabel: true,
      lineColor: '#ccc',
      tickColor: '#ccc',
      labels: {
        style: {
          fontSize: '12px',
          color: 'var(--text-secondary)'
        }
      }
    },
    xAxis: {
      lineColor: '#ccc',
      tickColor: '#ccc',
      labels: {
        style: {
          fontSize: '12px',
          color: 'var(--text-secondary)'
        }
      }
    },
    tooltip: {
      backgroundColor: 'white',
      shared: true,
      borderColor: 'white',
      borderRadius: 4,
      shadow: {
        color: 'black',
        offsetX: 0,
        offsetY: 1,
        width: 4
      }
    },
    plotOptions: {
      series: {
        marker: {
          animation: false
        },
        states: {
          hover: {
            lineWidthPlus: 0
          }
        }
      }
    }
  }
};
